import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const CashPages = {
  list: 'ListCash',
  add: 'AddCash',
  edit: 'EditCash',
}

const { t } = i18n.global

const title = t('pages.listCash')
const path = '/cashes'
const breadcrumb = [{ title, path }]

const cashFormComponent = () => import('@/pages/mainPageWithRoute/cash/FormCashPage.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: CashPages.add,
  component: cashFormComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: CashPages.edit,
  component: cashFormComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: CashPages.list,
  component: () => import('@/pages/mainPageWithRoute/cash/ListCashPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Cashes: RouteRecordRaw = {
  path,
  name: 'Cashes',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
